@if (isSidebarOpen) {
  <app-side-bar-products (sidebarToggle)="onSidebarToggle($event)"
  [currentUser]="currentUser"></app-side-bar-products>
}
<div class="main-content">
  <app-side-menu></app-side-menu>
  <div class="right-content">
    <app-top-menu></app-top-menu>
    @if (isLoading) {
      <div class="loading-animation">
        <app-loading></app-loading>
      </div>
    } @else {
      @if (areBoosterLoaded && AuthService.hasPermissions(['31'])) {
        <div>
          @if (boosters.length > 0 && shouldBoosterBeOpened) {
            <booster-list class="booster-info" [boosters]="boosters"
              [currentUser]="currentUser" (shouldBoosterBeOpened)="shouldBoosterBeOpened = $event"
              (isModalOpen)="isBoosterProdModalOpen($event)">
            </booster-list>
          }
        </div>
      }
      @if (this.currentUser.role !== 'Laboratorio') {
        <div class="div-top-products-btn">
          <div (click)="onSidebarToggle(true)" class="top-produtos">
            <span>
              Smart list
            </span>
          </div>
        </div>
      }
      @if (BCampaignSelected !== undefined) {
        <div class="main-pub"
          (click)="goToCampaign(BCampaignSelected.id, BCampaignSelected.idLaboratorio!)">
          @if (thereIsBCampaign && !isBSlotToShowVideo && !imgExists()) {
            <img [src]="BCampaignSelected.image"
              alt="Imagem de campanha principal" class="main-pub-img">
          }
          @if (thereIsBCampaign && isBSlotToShowVideo && !imgExists()) {
            <video [src]="BCampaignSelected.image"
            alt="Vídeo de campanha principal" class="main-pub-img" autoplay loop muted></video>
          }
        </div>
      }
      @if (BCampaignSelected === undefined && randomVideoSrc !== undefined || imgExists() && this.thereIsBCampaign) {
        <div class="main-pub"
          >
          <div class="video-wrapper">
            <video autoplay muted loop id="banner-video" alt="Vídeo de Banner">
              <source src="{{randomVideoSrc}}" type="video/webm">
            </video>
          </div>
        </div>
      }
      @if (emDestaque && emDestaque.length > 0) {
        <div class="content-1">
          <div class="d-flex flex-column">
            <span class="span-pub">Produtos em destaque</span>
            <div class="d-flex flex-row align-self-center multiple-cards-prod">
              @for (product of emDestaque | slice:0:4; track product) {
                <app-product-shop [product]="product"
                  (isModalOpen)="isProdModalOpen($event)">
                </app-product-shop>
              }
            </div>
            <div class="d-flex all-products-div">
              <span class="all-products-span" (click)="goTodosProdutos()">Todos os produtos em destaque ></span>
            </div>
          </div>
        </div>
      }
      <div class="content d-flex flex-column" style="justify-content: center;">
        @if (homeCampList.length <= 0 || !AuthService.hasPermissions(['4'])) {
          <div class="campaign-row last-item welcome w-100">
            <div class="welcome-item">
              <!-- <h3>Bem-vindo(a), {{currentUser.name}}</h3>
              <h1>AO SEU PORTAL VETERENÁRIO</h1> -->
            </div>
          </div>
        } @else {
          <span class="span-pub">As nossas campanhas</span>
          <div class="w-100 d-flex" style="justify-content: center !important;">
            <div class="uk-container">
              @if (P1CampaignSelected !== undefined) {
                <div
                  (click)="goToCampaign(P1CampaignSelected.id, P1CampaignSelected.idLaboratorio!)"
                  class="item-general item1">
                  @if (!this.isP1SlotToShowVideo && P1CampaignSelected.image) {
                    <img [src]="P1CampaignSelected.image"
                      alt="Imagem publicitária de campanha 1">
                  }
                  @if (!this.isP1SlotToShowVideo && !P1CampaignSelected.image) {
                    <img
                      src="../../../../assets/images/P1CampaignPlaceholder.png" alt="Imagem publicitária de campanha 1">
                    }
                    @if (!!this.isP1SlotToShowVideo) {
                      <div class="video-wrapper">
                        <video autoplay muted loop id="p1-video" id="banner-video" alt="Vídeo publicitário de Campanha 1"
                          style="border-radius: 15px;">
                          <source src="{{P1CampaignSelected.image}}" type="video/webm">
                        </video>
                      </div>
                    }
                  </div>
                }
                @if (P2CampaignSelected !== undefined) {
                  <div
                    (click)="goToCampaign(P2CampaignSelected.id, P2CampaignSelected.idLaboratorio!)"
                    class="item-general item2">
                    @if (!this.isP2SlotToShowVideo && P2CampaignSelected.image) {
                      <img [src]="P2CampaignSelected.image"
                        alt="Imagem publicitária de campanha 2">
                    }
                    @if (!this.isP2SlotToShowVideo && !P2CampaignSelected.image) {
                      <img
                        src="../../../../assets/images/P3CampaignPlaceholder.png" alt="Imagem publicitária de campanha 2">
                      }
                      @if (!!this.isP2SlotToShowVideo) {
                        <div class="video-wrapper">
                          <video autoplay muted loop id="p2-video" id="banner-video" alt="Vídeo publicitário de campanha 2"
                            style="border-radius: 15px;">
                            <source src="{{P2CampaignSelected.image}}" type="video/webm">
                          </video>
                        </div>
                      }
                    </div>
                  }
                  @if (P3CampaignSelected !== undefined) {
                    <div
                      (click)="goToCampaign(P3CampaignSelected.id, P3CampaignSelected.idLaboratorio!)"
                      class="item-general item3">
                      @if (!this.isP3SlotToShowVideo && P3CampaignSelected.image) {
                        <img [src]="P3CampaignSelected.image"
                          alt="Imagem publicitária de campanha 3">
                      }
                      @if (!this.isP3SlotToShowVideo && !P3CampaignSelected.image) {
                        <img
                          src="../../../../assets/images/P3CampaignPlaceholder.png" alt="Imagem publicitária de campanha 3">
                        }
                        @if (!!this.isP3SlotToShowVideo) {
                          <div class="video-wrapper">
                            <video autoplay muted loop id="p3-video" id="banner-video" alt="Vídeo publicitário de campanha 3"
                              style="border-radius: 15px;">
                              <source src="{{P3CampaignSelected.image}}" type="video/webm">
                            </video>
                          </div>
                        }
                      </div>
                    }
                    @if (P4CampaignSelected !== undefined) {
                      <div
                        (click)="goToCampaign(P4CampaignSelected.id, P4CampaignSelected.idLaboratorio!)"
                        class="item-general item4 last-item">
                        @if (!this.isP4SlotToShowVideo && P4CampaignSelected.image) {
                          <img [src]="P4CampaignSelected.image"
                            alt="Imagem publicitária de campanha 4">
                        }
                        @if (!this.isP4SlotToShowVideo && !P4CampaignSelected.image) {
                          <img
                            src="../../../../assets/images/P4CampaignPlaceholder.png" alt="Imagem publicitária de campanha 4">
                          }
                          @if (!!this.isP4SlotToShowVideo) {
                            <div class="video-wrapper">
                              <video autoplay muted loop id="p4-video" id="banner-video" alt="Vídeo publicitário de campanha 4"
                                style="border-radius: 15px;">
                                <source src="{{P4CampaignSelected.image}}" type="video/webm">
                              </video>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            <app-footer></app-footer>
          </div>
          <div class="app-backdrop" [ngClass]="{ 'open': isModalOpen }"></div>
        </div>